<template>
	<v-list density="compact" min-width="240">
		<v-list-item v-if="absenceMenuStore.absenceList.isLoading">
			<div class="d-flex align-center justify-center py-2">
				<v-progress-circular indeterminate size="20" width="2" color="primary" />
			</div>
		</v-list-item>

		<v-list-item v-else-if="absenceMenuStore.absenceList.items.length === 0" disabled>
			<v-list-item-title class="text-caption text-medium-emphasis">{{ t('no_absences_available') }}</v-list-item-title>
		</v-list-item>

		<v-list-item v-else v-for="absence in absenceMenuStore.absenceList.items" :key="absence.id" @click="handleRowClick(absence.id)">
			<v-list-item-title class="d-flex align-center gap-2">
				{{ t(`absence.type.${absence.type}`) }}
				<v-chip size="x-small" :color="statusColor(absence.status)" variant="flat" class="ml-1" rounded="lg">
					{{ t(`absence.${absence.status}`) }}
				</v-chip>
			</v-list-item-title>

			<template #append>
				<v-icon v-if="!absenceMenuStore.isAbsenceLocked(absence)" size="16" @click.stop="handleEditClick(absence.id)"> mdi-pencil </v-icon>
			</template>
		</v-list-item>
	</v-list>
</template>

<script setup lang="ts">
import { usePlanningAbsenceMenuStore } from '@/rennovation/planning-view/store/usePlanningAbsenceMenuStore';
import { useI18n } from 'vue-i18n';

const absenceMenuStore = usePlanningAbsenceMenuStore();
const { t } = useI18n();

const handleRowClick = (absenceId: string) => {
	absenceMenuStore.openInfoModal(absenceId);
	absenceMenuStore.closeContextMenu();
};

const handleEditClick = (absenceId: string) => {
	absenceMenuStore.openEditModal(absenceId);
	absenceMenuStore.closeContextMenu();
};

const statusColor = (status: string) => {
	switch (status?.toLowerCase()) {
		case 'approved':
			return 'success';
		case 'pending':
			return 'warning';
		case 'rejected':
			return 'error';
		default:
			return 'grey';
	}
};
</script>

<style scoped>
:deep(.v-list-item__append) {
	gap: 4px !important;
}

:deep(.v-list-item__prepend) {
	margin-inline-end: 4px !important;
}
.text-disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
</style>
